import React, { useState, useEffect, useRef } from "react";
import Caret from "./Caret";

import cx from "classnames";

const DEFAULT_STYLES = {
  height: 0,
  transition: `height 400ms cubic-bezier(.12,.67,.53,1)`,
  overflow: "hidden",
};

const Drawer = ({ onClick, title, children, isClosed }) => {
  const drawerElement = useRef(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  useEffect(() => {
    setIsDrawerOpen(!isClosed);
    return () => {
      setIsDrawerOpen(false);
    };
  }, [isClosed]);

  return (
    <section className="drawer">
      <button
        className="drawer__button"
        onClick={() => {
          onClick();
          setIsDrawerOpen(!isDrawerOpen);
        }}
      >
        {title}
        <Caret
          className={cx("drawer__caret", {
            open: isDrawerOpen,
          })}
        />
      </button>
      <div
        className="drawer__container"
        style={{
          ...DEFAULT_STYLES,
          height: isDrawerOpen
            ? drawerElement.current.getBoundingClientRect().height
            : 0,
          overflow: "hidden",
        }}
      >
        <section className="drawer__interior" ref={drawerElement}>
          {children}
        </section>
      </div>
    </section>
  );
};

export default Drawer;
